import { DiscountCommissionIcon } from "assets/icons";

import { groupOrderItemsByPack } from "../../../../../helpers";
import { OrderAtomProps } from "../../OrderModal.types";
import { TotalBlock } from "./TotalBlock";

export const OrderCommission = ({ orderDetails }: OrderAtomProps) => {
  const grouped = groupOrderItemsByPack(orderDetails.items);

  const products = grouped.map((entry, index) => {
    if (entry.kind === "standalone") {
      const item = entry.item;
      const name = item.barcode?.productVariant?.name ?? "";
      const qtySuffix = item.quantity !== 1 ? ` (${item.quantity})` : "";
      return {
        label: `${name}${qtySuffix}`,
        price: item.commission * item.quantity
      };
    }

    const { group } = entry;
    const totalCommission = group.rows.reduce(
      (sum, row) => sum + row.commission * row.quantity,
      0
    );
    const priceCarrier = group.rows.find((row) => row.isPackPriceCarrier);
    const label =
      group.packTitle ??
      priceCarrier?.barcode?.productVariant?.name ??
      `Pack #${index + 1}`;
    return { label, price: totalCommission };
  });

  return (
    <TotalBlock
      label="Commission"
      items={products}
      totalPrice={orderDetails.totalCommission}
      totalText="Total Commission"
      totalIcon={<DiscountCommissionIcon />}
      colors={{ backgroundColor: "#E6F9F5", color: "#03BF9D" }}
    />
  );
};
